<template>
    <section class="team-timeline" aria-label="Cronologia della giornata">
        <h3 class="t-title-3">La giornata, in ordine</h3>
        <div class="team-timeline__controls">
            <div role="group" aria-label="Intervallo della barra">
                <v-btn small outlined :aria-pressed="!fullDay" @click="fullDay = false">Turno</v-btn>
                <v-btn small outlined :aria-pressed="fullDay" @click="fullDay = true">24 ore</v-btn>
            </div>
            <div role="group" aria-label="Filtro cronologia">
                <v-btn small outlined :aria-pressed="!onlyIdle" @click="onlyIdle = false">Tutto</v-btn>
                <v-btn small outlined :aria-pressed="onlyIdle" @click="onlyIdle = true">Solo fermi</v-btn>
            </div>
        </div>
        <div class="mc-legend"><span><i class="mc-key mc-fill-1" />Attività</span><span><i class="mc-key mc-fill-3" />Tempi morti</span><span><i class="mc-key team-timeline__pause" />Pausa 12–13</span><span><i class="mc-key mc-fill-6" />Fuori presenza conteggiata</span></div>
        <div class="team-timeline__track" role="img" :aria-label="barLabel">
            <span v-for="(segment, i) in barSegments" :key="i" :class="fill(segment.tipo)" :style="position(segment)" :title="description(segment)">
                <span v-if="segment.tipo === 'pausa'" class="team-timeline__pause-label">Pausa 12–13</span>
            </span>
        </div>
        <div class="team-timeline__axis mc-caption"><span v-for="(tick, i) in ticks" :key="i">{{ tick }}</span></div>
        <p class="mc-caption">Pausa e spazi grigi non concorrono ai tempi morti. Le attività contemporanee contano una sola volta. Il filtro agisce solo sull’elenco.</p>
        <ol class="team-timeline__list">
            <team-presence-marker v-if="boundaries && !onlyIdle" :marker="boundaries.entry" entry :day-start="report.inizio_giornata" :day-end="report.fine_giornata" />
            <li v-for="segment in counted" :key="segment.inizio" :class="{ 'team-timeline__idle': segment.tipo === 'tempo_morto', 'team-timeline__group': segment.tipo === 'attivita' }">
                <team-activity-group v-if="segment.tipo === 'attivita'" :group="segment" :by-id="byId" />
                <template v-else>
                    <span class="team-timeline__time">{{ clockTime(segment.inizio) }}–{{ clockTime(segment.fine) }}</span>
                    <strong>{{ label(segment) }}</strong>
                    <strong class="team-timeline__duration">{{ timeDuration(segment.minuti, segment.tipo === 'tempo_morto') }}</strong>
                </template>
            </li>
            <team-presence-marker v-if="boundaries && !onlyIdle" :marker="boundaries.exit" :day-start="report.inizio_giornata" :day-end="report.fine_giornata" />
        </ol>
        <p v-if="!counted.length" class="mc-caption" role="status">{{ onlyIdle ? 'Nessun fermo superiore a 5 minuti in questa giornata.' : 'Nessun intervallo di presenza conteggiata in questa giornata.' }}</p>
        <details v-if="outsideActivities.length && !onlyIdle"><summary class="mc-label">Attività senza sovrapposizione alla presenza conteggiata ({{ outsideActivities.length }})</summary><ul><li v-for="a in outsideActivities" :key="a.id">{{ clockTime(a.inizio) }}–{{ clockTime(a.fine) }} · {{ activityLabel(a) }}</li></ul></details>
    </section>
</template>
<script>
import { timeDuration } from "./duration-model.mjs";
import { activityLabel, clockTime, segmentLabels } from "./day-model.mjs";
import { groupTimeline, activityGroupLabel, presenceBounds } from "./timeline-model.mjs";
import { timelineWindow, timelineTicks, lunchSegments, visibleSegments, segmentPosition, timelineRows } from "./timeline-view.mjs";
import TeamActivityGroup from "./TeamActivityGroup.vue";
import TeamPresenceMarker from "./TeamPresenceMarker.vue";
export default {
    name: "TeamDayTimeline",
    components: { TeamActivityGroup, TeamPresenceMarker },
    props: { report: { type: Object, required: true } },
    data: () => ({ fullDay: false, onlyIdle: false }),
    computed: {
        byId() { return Object.fromEntries(this.report.attivita.map(a => [a.id, a])); },
        boundaries() { return presenceBounds(this.report.presenze); },
        segments() { return lunchSegments(groupTimeline(this.report.segmenti), this.report.giorno); },
        window() { return timelineWindow(this.report, this.fullDay); },
        barSegments() { return visibleSegments(this.segments, this.window); },
        counted() { return timelineRows(this.segments, this.onlyIdle); },
        outsideActivities() { return this.report.attivita.filter(a => !a.minuti_presenza); },
        barLabel() { return this.barSegments.map(this.description).join("; ") || "Nessuna presenza conteggiata"; },
        ticks() { return timelineTicks(this.window, this.report); },
    },
    methods: {
        timeDuration, activityLabel, clockTime,
        fill(kind) { return kind === "pausa" ? "team-timeline__pause" : kind === "attivita" ? "mc-fill-1" : kind === "tempo_morto" ? "mc-fill-3" : "mc-fill-6"; },
        label(s) { return s.tipo === "pausa" ? "Pausa 12–13" : s.tipo === "attivita" ? activityGroupLabel(s, this.byId) : segmentLabels[s.tipo]; },
        description(s) { return `${clockTime(s.inizio)}–${clockTime(s.fine)}: ${this.label(s)}, ${timeDuration(s.minuti, s.tipo === "tempo_morto")}`; },
        position(s) { return segmentPosition(s, this.window); },
    },
};
</script>
